
function isMobile() {
  return window.matchMedia("(max-width: 768px)").matches;
}

if (isMobile()) {
  const slides = document.querySelector('.story-scroll-slide');
  const slide = document.querySelectorAll('.story-scroll-slide__items');
  const nextBtn = document.getElementById('nextBtn');
  const prevBtn = document.getElementById('prevBtn');
  
  let currentIndex = 0;
  
  // Function to update the slider position
function showSlide(index) {
    const slideWidth = slide[0].clientWidth;
    slides.style.transform = `translateX(${-slideWidth * index}px)`;
    updateButtons();
}

// Function to enable/disable buttons based on the current slide
function updateButtons() {
    prevBtn.disabled = currentIndex === 0; // Disable "Prev" if at the first slide
    nextBtn.disabled = currentIndex === slide.length - 1; // Disable "Next" if at the last slide
}

  // Event listeners for next and prev buttons
  nextBtn.addEventListener('click', () => {
      if (currentIndex < slide.length - 1) {
          currentIndex++;
          showSlide(currentIndex);
      }
  });

  prevBtn.addEventListener('click', () => {
      if (currentIndex > 0) {
          currentIndex--;
          showSlide(currentIndex);
      }
  });

  // Initialize slider on page load
  showSlide(currentIndex);
}
